import {
  Row,
  Col,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import React, { useState, useEffect } from "react"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import Loading from 'lib/loading'

const ListaLojas = ({ form, onChange }) => {

  const [lojas, setLojas]     = useState([])
  const [loading, setLoading] = useState(true)

  const lista = () => {
    try{
      const retorno = rest.get(rotas.lojas+'controle.php')
      retorno.then(ret => {
        // console.log(ret)
        if ((ret.success) && (ret.success == 'S') && (ret.lista != '')){
          setLojas(ret.lista)
        }
      })
      setLoading(false)
      return (true)
    }catch(err){
      return (false)
    }
  }

  useEffect(() => {
    lista()
  },[])


  const listaCheckbox = lojas.map((loja, index) => {
    return (
      <Row key={loja.filial_id+index}>
      <Col className="p-0" md="6">
        <FormGroup className="m-6" check>
          <Label style={{paddingLeft: '30px'}} check>
            <Input
              type      = "checkbox"
              id        = {"lojasItem" + loja.filial_id}
              key       = {"lojasItem" + loja.filial_id}
              name      = "fidelidade"
              label     = {loja.nome}
              checked   = {form.lojas[loja.filial_id] == 'S' ? true : false}
              onChange  = {onChange(loja.filial_id, 'lojas')}
            />
            <span className="form-check-sign" />{loja.fantasia}
          </Label>
        </FormGroup>
      </Col>
      </Row>
    )
  })


  if (loading) {
    return (
      <Row>
        <Loading tipo='componente' />
      </Row>
    )
  } else {
    return (
      <Col md='12'>
        {listaCheckbox}
      </Col>
    )
  }

}

export default ListaLojas
